// src/components/RiskBreakdown.js
import React from 'react';

const RiskBreakdown = ({ scores }) => {
  const categories = [
    { key: 'psychological', label: 'Psychological Risk Tolerance', color: 'bg-arc-gold' },
    { key: 'financial', label: 'Financial Capacity', color: 'bg-green-500' },
    { key: 'experience', label: 'Trading Experience', color: 'bg-purple-500' },
    { key: 'preference', label: 'Risk Preference', color: 'bg-yellow-500' },
    { key: 'scenario', label: 'Scenario Responses', color: 'bg-red-500' }
  ];

  return (
    <div className="mb-12">
      <h3 className="text-xl font-semibold text-arc-ink mb-4">Risk Category Breakdown</h3>
      <div className="space-y-4">
        {categories.map(category => (
          <div key={category.key}>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium text-arc-muted">{category.label}</span>
              <span className="text-sm font-medium text-arc-muted">{scores[category.key]?.toFixed(1)}%</span>
            </div>
            <div className="w-full bg-white/[0.08] rounded-full h-2.5">
              <div 
                className={`${category.color} h-2.5 rounded-full transition-all duration-1000 ease-out`} 
                style={{ width: `${scores[category.key] || 0}%` }} 
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskBreakdown;